import { CarvanaEmblem, CarvanaHorizontal } from '@carvana/ds-icons';
import React from 'react';
import LockTimer from '|/app/header/purchase-header/components/lock-timer';
import { SupportContactLink } from '|/components/support-contact';
import styles from './header-content.module.css';
import type { HeaderContentProps } from './types';
import EditOrderLink from '../edit-order-link';

const HeaderContent = ({
  orderSummary,
  isMobileNative,
  onLogoClick,
  onSupportClick,
  onLockTimerClick,
  onEditOrder
}: HeaderContentProps) => (
  <div className={styles.headerContent}>
    {/* Mobile: "Edit order" replaces the emblem + divider + "Checkout" lockup */}
    <div className={styles.mobileLeft}>
      {onEditOrder && (
        <EditOrderLink onClick={onEditOrder} data-analytics-id="pp_checkout_header_edit_order" />
      )}
    </div>

    {/* Mobile: emblem moves to the centre */}
    {!isMobileNative && (
      <a
        href="/"
        className={styles.mobileEmblem}
        onClick={e => {
          e.preventDefault();
          onLogoClick();
        }}
        data-analytics-id="pp_header_home"
        aria-label="Carvana Home"
      >
        <CarvanaEmblem className={styles.emblem} />
      </a>
    )}

    {/* Desktop: full Carvana logo */}
    {!isMobileNative && (
      <a
        href="/"
        className={styles.desktopLogo}
        onClick={e => {
          e.preventDefault();
          onLogoClick();
        }}
        data-analytics-id="pp_header_home"
        aria-label="Carvana Home"
      >
        <CarvanaHorizontal className={styles.carvanaLogo} />
      </a>
    )}

    <div className={styles.rightContent}>
      <div className={styles.supportSlot}>
        <SupportContactLink onClick={onSupportClick} />
      </div>

      <LockTimer
        orderSummary={orderSummary}
        onClick={onLockTimerClick}
        plain={true}
        data-analytics-id="pp_header_lock_timer"
      />
    </div>
  </div>
);

export default HeaderContent;
